import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@Services/auth.service';

@Component({
    selector: 'app-login-required',
    imports: [TranslateModule],
    templateUrl: './login-required.component.html',
    styleUrl: './login-required.component.scss'
})
export class LoginRequiredComponent {

  private readonly authSvc = inject(AuthService);

  public login() {
    this.authSvc.login();
  }
}
